<template>
	<div style="position: relative">
		<div style="padding-top: 20px; height: calc(100vh - 80px - env(safe-area-inset-bottom)); overflow: auto; padding-bottom: calc(80px + env(safe-area-inset-bottom));">
			<van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="onRefresh">
			  <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" error-text="请求失败，点击重新加载" @load="refreshList">
				<!-- <van-cell v-for="item in list" :key="item" :title="item.type" />
				<van-cell v-for="item in list" :key="item" :title="item.invoiceNum" />
				<van-cell v-for="item in list" :key="item" :title="item.purchaserName" />
				<van-cell v-for="item in list" :key="item" :title="Number(item.amount).toFixed(2)" /> -->
          <van-checkbox-group v-model="invoiceIds">
            <div class="list" v-for="(item, index) in list" :key="index">
              <div style="margin-left: 10px; width: 32px; display: flex; align-items: center">
                <van-checkbox v-if="item.isLink === '0'" ref="checkbox" shape="square" :name="item.id" icon-size="28px"></van-checkbox>
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'vat_invoice'">
                <div class="item-name">增值税发票</div>
                <div class="item-sellName">销售方：{{item.sellerName}}</div>
                <div class="item-amount">价税合计：{{Number(item.amount).toFixed(2)}}</div>
                <!--              <div class="item-good">税目：{{item.vatInvoiceDetails[0].name}}</div>-->
                <!--            <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'taxi_receipt'">
                <div class="item-name">出租车票</div>
<!--                <div class="item-sellName">发票代码：{{item.invoiceCode}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
<!--                <div class="item-amount">日期：{{item.date}}</div>-->
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'train_ticket'">
                <div class="item-name">火车票</div>
                <div class="item-sellName">车票号：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-amount">乘客姓名：{{item.name}}</div>-->
<!--                <div class="item-amount">身份证号：{{item.idCard}}</div>-->
<!--                <div class="item-amount">出发日期：{{item.date}}</div>-->
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'quota_invoice'">
                <div class="item-name">定额发票</div>
<!--                <div class="item-sellName">发票代码：{{item.invoiceCode}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'air_ticket'">
                <div class="item-name">飞机行程单</div>
<!--                <div class="item-sellName">姓名：{{item.airTicket.name}}</div>-->
<!--                <div class="item-amount">航班号：{{item.airTicket.flight}}</div>-->
<!--                <div class="item-amount">日期：{{item.airTicket.date}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'roll_normal_invoice'">
                <div class="item-name">卷票</div>
<!--                <div class="item-sellName">销售方：{{item.rollNormalInvoice.sellerName}}</div>-->
<!--                <div class="item-amount">发票代码：{{item.rollNormalInvoice.invoiceCode}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'printed_invoice'">
                <div class="item-name">机打发票</div>
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-sellName">销售方：{{item.printedInvoice.sellerName}}</div>-->
<!--                <div class="item-amount">发票代码：{{item.printedInvoice.invoiceCode}}</div>-->
<!--                <div class="item-amount">发票号码：{{item.printedInvoice.invoiceNum}}</div>-->
                <!--					<div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'bus_ticket'">
                <div class="item-name">汽车票</div>
<!--                <div class="item-sellName">姓名：{{item.busTicket.name}}</div>-->
<!--                <div class="item-amount">发票代码：{{item.busTicket.invoiceCode}}</div>-->
<!--                <div class="item-amount">发票号码：{{item.busTicket.invoiceNum}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'toll_invoice'">
                <div class="item-name">过路过桥费</div>
<!--                <div class="item-amount">发票代码：{{item.tollInvoice.invoiceCode}}</div>-->
<!--                <div class="item-amount">发票号码：{{item.tollInvoice.invoiceNum}}</div>-->
<!--                <div class="item-amount">日期：{{item.tollInvoice.outDate}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'ferry_ticket'">
                <div class="item-name">船票</div>
<!--                <div class="item-amount">发票代码：{{item.ferryTicket.invoiceCode}}</div>-->
<!--                <div class="item-amount">发票号码：{{item.ferryTicket.invoiceNum}}</div>-->
<!--                <div class="item-amount">出发地点：{{item.ferryTicket.exitStation}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'motor_vehicle_invoice'">
                <div class="item-name">机动车销售发票</div>
<!--                <div class="item-sellName">销售方：{{item.motorVehicleInvoice.saler}}</div>-->
<!--                <div class="item-amount">发票代码：{{item.motorVehicleInvoice.invoiceCode}}</div>-->
<!--                <div class="item-amount">发票号码：{{item.motorVehicleInvoice.invoiceNum}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'used_vehicle_invoice'">
                <div class="item-name">二手车销售发票</div>
<!--                <div class="item-sellName">销售方：{{item.usedVehicleInvoice.saler}}</div>-->
<!--                <div class="item-amount">发票代码：{{item.usedVehicleInvoice.invoiceCode}}</div>-->
<!--                <div class="item-amount">发票号码：{{item.usedVehicleInvoice.invoiceNum}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <div class="row-item" @click="viewInvoice(item)" v-if="item.type == 'taxi_online_ticket'">
                <div class="item-name">网约车行程单</div>
<!--                <div class="item-sellName">服务商：{{item.taxiOnlineTicket.serviceProvider}}</div>-->
<!--                <div class="item-amount">行程开始时间：{{item.taxiOnlineTicket.startTime}}</div>-->
<!--                <div class="item-amount">行程结束时间：{{item.taxiOnlineTicket.destinationTime}}</div>-->
<!--                <div class="item-amount">行程人手机号：{{item.taxiOnlineTicket.phone}}</div>-->
                <div class="item-amount">发票号码：{{item.invoiceNum}}</div>
                <div class="item-amount">金额：{{Number(item.amount).toFixed(2)}}</div>
<!--                <div class="item-errorMsg" v-if="item.errorMsg != ''">错误信息：{{item.errorMsg}}</div>-->
              </div>
              <van-icon v-if="item.isLink === '0'" name="delete-o" size="24" color="#EE0A24" @click="deleteBill(item)"/>
            </div>
          </van-checkbox-group>
			  </van-list>
			</van-pull-refresh>
		</div>
    <div style="width: 100%;height: 60px;position: absolute;bottom: calc(4px + env(safe-area-inset-bottom));text-align: center; display: flex; align-items: center; justify-content: space-evenly; z-index: 999; background-color:#fff;">
      <van-uploader :after-read="afterRead" accept="*">
        <van-button type="info">拍照上传</van-button>
      </van-uploader>
        <van-button type="info" @click="selectExpense">关联报销单</van-button>
    </div>
		<van-tabbar v-model="active" :fixed="true" :placeholder="false" :safe-area-inset-bottom="true">
		  <van-tabbar-item icon="home-o">发票</van-tabbar-item>
		  <van-tabbar-item icon="search" route replace to="/list">报销单</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	import InvoiceService from '@/api/invoice/InvoiceService.js' ;
	//import Vue from "vue";
	
	export default {
		data() {
			return {
				active: 0,
				list: [],
				loading: false,
				finished: false,
				error: false,
        current: 1,
        size: 10,
        total: 0,
        invoiceIds: []
			}
		},
    created() {
      localStorage.setItem('results', JSON.stringify([]))
    },
    activated() {
      localStorage.setItem('results', JSON.stringify([]))
      // this.onRefresh()
		},
		methods: {
			onRefresh() {
				this.current = 1
				this.size = 10
				this.list = []
				this.refreshList()
			},
			refreshList() {
				//Vue.cookie.set('token', "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0eXBlIjoic3lzIiwiZXhwIjoxNzMyOTQ2MjUwLCJ1c2VybmFtZSI6ImxpengifQ.427FlpedNwyFlJSxg0PDAVgnsfRBs2maQ9Iy3atdbm8");
				this.loading = true;
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
				new InvoiceService().list({
					current: this.current,
					pageSize: this.size
				}).then(({data}) => {
					this.list.push(...data.records)
					this.total = data.total
					this.loading = false
					this.finished = this.total / this.size <= this.current
					if (!this.finished) {
						this.current += 1
					}
					this.$toast.clear();
				}).catch(()=>{
					this.loading = false;
					this.error = true
          this.$toast.clear();
					// this.finished = true;
				})
			},
      overSize(){
			  this.$toast.fail('图片大小不能超过4M');
      },
			afterRead(file){
        if(file.file.name.split('.')[file.file.name.split('.').length - 1] === 'pdf') {
          this.uploadImage(file.file)
          return
        }
        let maxSize = 4 * 1024 * 1024; // 4MB
        let size = file.file.size
        if(size > maxSize) {
          // 预估压缩比例并减去 0.1 作保险
          let estimatedRatio = maxSize / size - 0.1;
          // 限制最小压缩比，防止过度压缩
          let minRatio = 0.2;
          let finalRatio = Math.max(estimatedRatio, minRatio);
          this.compressImage(file, finalRatio)
        } else {
          this.uploadImage(file.file)
        }
			},
      compressImage(file, compressRatio){
        // 创建 FileReader 读取文件
        // if(file.file.)
        const reader = new FileReader();
        reader.readAsDataURL(file.file);
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            // 设定目标宽度和高度（可以根据需要调整）
            const maxWidth = 800;
            const maxHeight = 800;
            let width = img.width;
            let height = img.height;

            if (width > maxWidth || height > maxHeight) {
              const scale = Math.min(maxWidth / width, maxHeight / height);
              width = width * scale;
              height = height * scale;
            }

            // 创建 canvas 进行压缩
            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            // 输出压缩后的图片（质量 0.7 可调整）
            canvas.toBlob((blob) => {
              if (!blob) {
                Toast.fail("压缩失败");
                return;
              }
              const compressedFile = new File([blob], file.file.name, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });

              this.uploadImage(compressedFile); // 处理上传
            }, "image/jpeg", compressRatio);
          };
        };
      },
      uploadImage(file){
        // console.log(file)
        // alert(file.size, '2')
        if(file.size > 4 * 1024 * 1024){
          this.overSize()
          return
        }
        const formData = new FormData();
        formData.append('module', 'invoice');
        formData.append('file', file);
        this.loading = true;
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        })
        new InvoiceService().upload(formData).then(({data}) => {
          // console.log(data.url)
          let form = {
            files: JSON.stringify([
              {
                path: data.url,
                src: data.url
              }
            ]),
            category: 2
          }

          new InvoiceService().multipleInvoice(form).then(({data}) => {
            let num = data.num;//无法识别数量
            let size = data.size;//文件数量
            let msg = data.msg;
            if(num > 0){
              this.$toast.clear();
              this.$toast.fail('总数量：'+size+'，未识别数量：'+num+(msg != ''?'，'+msg:''));
            }else{
              if(msg === '无法识别'){
                this.$toast.clear();
                //this.$toast.success(msg);
                this.$dialog.confirm({message: msg+'，是否新增发票？'}).then(()=>{
                  this.$router.push({
                    path: '/invoiceInfo',
                    query: {
                      data: encodeURIComponent(JSON.stringify({})),
                      type: 'vat_invoice',
                      billDetails: encodeURIComponent(JSON.stringify([])),
                      method: 'add',
                      result: encodeURIComponent(JSON.stringify({}))
                    }
                  })
                })
              }
            }
            if(size >= num){
              localStorage.setItem('results', JSON.stringify(data.results))
              this.$router.push({
                path: '/invoiceList',
              })
            }
            this.$toast.clear();
            this.loading = false;
          })
        })
      },
      deleteBill(item){
        this.$dialog.confirm({message: '确定删除该发票吗？'}).then(()=>{
          this.$toast.loading({ forbidClick: true, message: '数据加载中', duration: 0 })
          new InvoiceService().deleteBill({
            id: item.id,
            type: item.type,
            invoiceId: item.invoiceId
          }).then(({data}) => {
            this.$toast.success(data.msg)
            this.$toast.clear()
            this.onRefresh()
          }).catch((err) =>{
            this.$toast.fail(err.data.msg)
          })
        })
      },
      selectExpense(){
        if(this.invoiceIds.length > 0) {
          this.$router.push({
            path: '/expenseSelect',
            query: {
              invoiceIds: this.invoiceIds
            }
          })
        } else {
          this.$toast.fail('请选择发票')
        }
      },
      viewInvoice(item){
        this.$router.push({
          path: '/invoiceInfoDetail',
          query: {
            type: item.type,
            invoiceId: item.invoiceId,
            method: 'view',
          }
        })
      }
		}
	}
</script>

<style scoped>
.list{
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #EEEEEE;
}
.row-item{
  width: 85%;
  padding: 5px 5px 8px 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.item-name{
  width: 280px;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #e29700;
}
.item-sellName{
  width: 280px;
  font-size: 11px;
  color: #000000;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item-amount{
  font-size: 11px;
  display:block;
  color: #4D4D4D;
}
</style>
